module.exports = __webpack_public_path__ + "static/media/claims-amc.39715005.svg";